export default () => {
  const appSearchResultDOMNode = dom.querySelector(
    ".render-app-search-results"
  );

  const searchInputDOMNode = dom.querySelector(
    ".search-input input[type=text]"
  );

  let disposeApp: DisposableApp = null;
  let disposing = false;
  if (appSearchResultDOMNode !== null && searchInputDOMNode !== null) {
    import("./index" /* webpackChunkName: "app-search-results" */).then(
      ({ default: startApp }) => {
        if (!disposing) {
          disposeApp = startApp(appSearchResultDOMNode, searchInputDOMNode);
        }
      }
    );
  }

  return function disposeCallback() {
    disposing = true;

    if (disposeApp !== null) {
      disposeApp();
    }
  };
};
